import React, { useState } from "react";
import S3Image from "../util/S3Image";

const VideoSection = ({ video_url, placeholderImage }) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handlePlayVideo = () => {
    setIsVideoLoaded(true);
  };

  return (
    <div className="pt-4 overflow-hidden">
      <div className="flex items-center justify-center">
        <div className="relative transform bg-surianceBlue p-[5vw] shadow-md transition-transform hover:scale-110 md:my-6 md:p-6">
          {isVideoLoaded || !placeholderImage ? (
            <iframe
              className="h-[56vw] w-[90vw] md:h-[450px] md:w-[800px]"
              src={video_url}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div onClick={handlePlayVideo} className="cursor-pointer">
              <S3Image
                img={placeholderImage}
                alt="Video Placeholder"
                className="h-[56vw] w-[90vw] md:h-[450px] md:w-[800px]"
              />
              <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center">
                <span className="transform rounded-sm bg-surianceBlue px-4 py-4 text-lg font-bold text-white transition-transform hover:scale-105 hover:bg-surianceBlue md:text-2xl">
                  Click To Play ▶️
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default VideoSection;
